<template>
    <div class="horizontal grow gallery-container" style="width: 70vw; height: 70vh">
        <div id="info-container">
            <div>
                <p class="section-title">{{$t('SYSTEM_INFORMATION')}}</p>
                <div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{$t('SystemName')}}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="system.systemName" type="text" :placeholder="$t('SystemName')">
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{$t('FarmName')}}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="system.farmName" type="text" :placeholder="$t('FarmName')" list="farmsid">
                                <datalist id="farmsid">
                                  <option v-for="farm in farms" :key="farm.id">
                                    {{ farm }}
                                  </option>
                                </datalist>
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{$t('Address')}}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="system.address" type="text" :placeholder="$t('Address')">
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{$t('Country')}}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="system.country" type="text" :placeholder="$t('Country')" list="countries">
                                <datalist id="countries">
                                  <option v-for="(country, index) in countries" :key="index">
                                    {{country.name}}
                                  </option>
                                </datalist>
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{$t('Description')}}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="system.description" type="text" :placeholder="$t('Description')">
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{$t('InstallationDate')}}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <date-picker :confirm="false" v-model="system.installation" :type="'date'" :clearable="false" :format="'DD-MM-YYYY'"></date-picker>
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{$t('UnderWarranty')}}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <date-picker :confirm="false" v-model="system.underWarranty" :type="'date'" :clearable="false" :format="'DD-MM-YYYY'"></date-picker>
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{$t('ServiceAgreement')}}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <date-picker :confirm="false" v-model="system.serviceAgreement" :type="'date'" :clearable="false" :format="'DD-MM-YYYY'"></date-picker>
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{$t('SystemGroup')}}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="system.systemsGroup" type="text" :placeholder="$t('SystemGroup')" list="groupsid">
                                <datalist id="groupsid">
                                  <option v-for="g in groups" :key="g.id">
                                    {{g.name}}
                                  </option>
                                </datalist>
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                      <tr class="info-field-row">
                        <td style="width:200px;">
                          <p class="info-field-title">{{$t('SystemType')}}</p>
                        </td>
                        <td style="width:200px;" class="info-field-value">
                          <select v-model="system.systemTypeId">
                            <option v-for="(systemType, index) in systemTypes" :key="index" :value="systemType.id">{{ systemType.name }}</option>
                          </select>
                        </td>
                      </tr>
                    </div>
                    <div>
                        <div class="error" v-if="error != ''">{{ error }}</div>
                    </div>
                </div>
            </div>
            <div style="align-self: center;">
                <Button :title="$t('Save')" buttonClass='save-button semi-bold' style="width: 300px; align-self: center;" @onClick="save"></Button>
            </div>
        </div>
        <div id="map-container">
            <div id="map" ref="map">
            </div>
        </div>
    </div>
</template>

<script>
import { addSystemWithDetails, editSystemWithDetails, getExistingGroups, getAllFarmsNames, getSystemTypes } from '@/api/api'
import Button from '../Button.vue';
import Select from '../Select'
import mapboxgl from 'mapbox-gl';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import countriesDataJson from '@/assets/json/countries.json'

export default {
    props: {
        systemObject: {
            required: false,
            type: Object
        }
    },
    components: {
        Button,
        Select,
        DatePicker
    },
    provide: {
    },
    data() {
        return {
            system: {
                systemName: '',
                farmName: '',
                address: '',
                country: '',
                description: '',
                installation: null,
                underWarranty: null,
                serviceAgreement: null,
                systemsGroup: '',
                systemTypeId: 1
            },
            coordinates: {
              lat: 0,
              lng: 0
            },
            error: "",
            countries: [],
            groups: [],
            farms: [],
            systemTypes: []
        }
    },
    computed: {
    },
    methods: {
        // Parsuje datę z API; niepoprawna/pusta lub sentinel „brak daty" (rok < 2011,
        // np. MinValue albo 1000-01-01 z backendu) → null, żeby date-picker pokazał
        // puste pole, a save() ją pominął.
        parseDateOrNull(value) {
          if (!value) {
            return null;
          }
          var dt = new Date(Date.parse(value));
          if (isNaN(dt.getTime()) || dt.getFullYear() < 2011) {
            return null;
          }
          return dt;
        },

        async getData() {
          if (this.systemObject != null) {
            this.coordinates.lat = this.systemObject.addressLatitude;
            this.coordinates.lng = this.systemObject.addressLongitude;

            this.system.id = this.systemObject.id;
            this.system.systemName = this.systemObject.systemName;
            this.system.farmName = this.systemObject.farmName;
            this.system.address = this.systemObject.address;
            this.system.country = this.systemObject.country;
            this.system.description = this.systemObject.comment;
            this.system.installation = this.parseDateOrNull(this.systemObject.installationDate);
            this.system.underWarranty = this.parseDateOrNull(this.systemObject.underWarranty);
            this.system.serviceAgreement = this.parseDateOrNull(this.systemObject.serviceAgreement);
            this.system.systemsGroup = this.systemObject.systemGroup
            this.system.systemTypeId = this.systemObject.systemTypeId
          }
        },

        async save() {
          this.system.addressLatitude = this.coordinates.lat;
          this.system.addressLongitude = this.coordinates.lng;

          if (this.system.installation instanceof Date && !isNaN(this.system.installation.getTime())){
              var dt = this.system.installation
              this.system.installationDate = `${dt.getFullYear()}-${dt.getMonth() + 1}-${dt.getDate()} 00:00:00`.toDateTime()
          }

          if (this.system.underWarranty instanceof Date && !isNaN(this.system.underWarranty.getTime())) {
            var dt = this.system.underWarranty
            this.system.underWarranty = `${dt.getFullYear()}-${dt.getMonth() + 1}-${dt.getDate()} 00:00:00`.toDateTime()
          }

          if (this.system.serviceAgreement instanceof Date && !isNaN(this.system.serviceAgreement.getTime())) {
            var dt = this.system.serviceAgreement
            this.system.serviceAgreement = `${dt.getFullYear()}-${dt.getMonth() + 1}-${dt.getDate()} 00:00:00`.toDateTime()
          }

          if (this.systemObject == null){
            this.error = ''
            await addSystemWithDetails(this.system)
              .then((d) => {
                this.$emit("save");
              }).catch((error) => {
                this.processError(error)
              })
          } else {
            this.error = ''
            await editSystemWithDetails(this.system)
              .then((d) => {
                this.$emit("save");
              }).catch((error) => {
                this.processError(error)
              })
          }
        },
        processError(error){
            if(error.response.data != undefined){
                this.error = error.response.data
            } else {
                // console.log({err: error.response})
                this.error = ""
            }
        },
        async createMap() {
          mapboxgl.accessToken = 'pk.eyJ1Ijoicml2aWpjenlrOTgiLCJhIjoiY2thNWxvYnZ4MDFhcjNtbXdlOGRkZHlpNyJ9.3yvf9A68MAvVM9OG1ZK9pg';

          this.map = new mapboxgl.Map({
              container: 'map', // container ID
              style: 'mapbox://styles/mapbox/satellite-streets-v11', // style URL
              center: [this.coordinates.lng, this.coordinates.lat], // starting position [lng, lat]
              zoom: 3 // starting zoom
          });

          this.map.addControl(new mapboxgl.NavigationControl());

          var marker = null;

          if (this.systemObject == null) {
            marker = new mapboxgl.Marker();
          } else
          {
            marker = new mapboxgl.Marker()
              .setLngLat([this.coordinates.lng, this.coordinates.lat])
              .addTo(this.map);
          }

          // marker.on('dragend', () => {
          //   const lngLat = marker.getLngLat();
          //   this.coordinates.lat = lngLat.lat;
          //   this.coordinates.lng = lngLat.lng;
          // });

          this.map.on('click', (event) => {
            var lngLat = event.lngLat;
            this.coordinates.lat = lngLat.lat;
            this.coordinates.lng = lngLat.lng;

            marker.setLngLat(lngLat).addTo(this.map);
          });

        }
    },
    mounted: async function() {

        this.groups = await getExistingGroups();
        this.farms = await getAllFarmsNames();
        this.farms.sort()
        this.systemTypes = await getSystemTypes();

        if (this.systemObject != null) {
            this.getData();
        }

      this.createMap();

      // const url = `https://api.teleport.org/api/countries/`;
      // await axios.get(url)
      //   .then((response) => {
      //     this.countries = response.data._links["country:items"];
      //   }).catch((error) => {

      //   });

      countriesDataJson.map((obj) => this.countries.push({ "name": obj.name.common }));
    }
}
</script>

<style scoped>

.error {
    text-align: left !important;
    color: #FD8282;
    font-size: 11px;
    font-weight: bold;
    font-family: 'Open Sans', sans-serif !important;
    font-style: normal !important;
    font-weight: 400 !important;
}

#info-container {
    width: 30%;
    padding: 20px;

    background: #FFFFFF;
    border: 1px solid #EFEFEF;
    box-sizing: border-box;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    border-radius: 5px 0px 0px 5px;

    justify-content: space-between;
    display: flex;
    flex-direction: column;
}

#systems-container {
    width: 50%;
    align-items: center;
    justify-content: center;
    /* margin: auto; */
}
#map-container {
    width: 70%;
}
.gallery-container {
    background: #F9F9F9;
    box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);
    border-radius: 5px;
}

.info-field {
    border-bottom: 1px solid #E9E9E9;
    margin-bottom: 12px;
    margin-top: 12px;
}

.info-field-title {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
    margin: 0;
}

.info-field-row {
    width: 100%;
    margin: 0;
    padding-bottom: 5px;
}

.info-field-value {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
}

.section-title {
    font-weight: bold;
}

input[type=text], input[type="email"], input[type="password"] {
    border: none;
    width: 100%;
}

input[type=text]:focus, input[type="email"]:focus, input[type="password"]:focus {
    border-bottom: 1px solid #0095b2;
    outline: none;
}

select {
    border: none;
    width: 100%;
}

select:focus {
    outline: none;
    border-bottom: 1px solid #0095b2;
}

option {
    padding: 4px;
}

option:checked {
    background: #347C93;
    color: white;
}


#map {
 height: 95%;
 background: gray;
 margin: 20px;
 border-radius: 5px;
}

.mx-datepicker {
  width: auto;
  padding: 0px 0px 0px 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Systems/SystemModal.vue